import { StatusBadge } from '@vrplatform/components';
import type { Maybe } from '@vrplatform/utils';

export const OwnerUserStatusBadge = (props: { status: Maybe<string> }) => {
  switch (props.status) {
    case 'active':
      return <StatusBadge label="Active" status="success" />;
    case 'unconfirmed':
    case 'pending':
      return <StatusBadge label="Invited" status="invited" />;
    case 'expired':
      return <StatusBadge label="Expired" status="expired" />;
    case 'archived':
      return <StatusBadge label="Archived" status="archived" />;
    default:
      return <StatusBadge label="Not invited" status="missing" />;
  }
};
